/**
 * values for setting the 'presentation' in opt in
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const OPT_IN_PRESENTATION = {
  CTA:      'presentation_cta',
  CHECKBOX: 'presentation_checkbox',
};

const OPT_IN_PRESENTATION_ALL = _.values(OPT_IN_PRESENTATION);

const OPT_IN_PRESENTATION_LIST = [
  { text: locale('Checkbox'), value: OPT_IN_PRESENTATION.CHECKBOX, description: '' },
  { text: locale('CTA'), value: OPT_IN_PRESENTATION.CTA, description: 'Allow users to opt-in, opt-out or skip.' },
];

export { OPT_IN_PRESENTATION, OPT_IN_PRESENTATION_LIST, OPT_IN_PRESENTATION_ALL };

export default OPT_IN_PRESENTATION;
